module.exports = __webpack_public_path__ + "img/csuperelasonly-uniaxial-nls.100645da.png";